export function getDarboDienaWord(n: number) {
  const lastDigit = n % 10;
  const lastTwoDigits = n % 100;
  if (n === 0) return "darbo dienų";
  if ((lastTwoDigits >= 11 && lastTwoDigits <= 19) || (lastTwoDigits >= 111 && lastTwoDigits <= 119)) return "darbo dienų";
  if (lastDigit === 1) return "darbo diena";
  if (lastDigit >= 2 && lastDigit <= 9) return "darbo dienos";
  return "darbo dienų";
}